import { useMutation } from "@tanstack/react-query";
import type { SampleAttributesPayload } from "../../models/lab.models";
import { upsertSampleAttributes } from "../../repositories/lab-de.repositories";

export const useSaveSampleAttributesMutation = () => {
  return useMutation({
    mutationFn: async (payload: SampleAttributesPayload) => {
      const resp = await upsertSampleAttributes(payload);
      if (!resp.ok)
        throw new Error(resp.message ?? "Failed to save sample attributes");
      return resp;
    },
  });
};
